<template>
  <div class="hello">
    <div class="home-container" style="opacity: 0;"></div>

    <van-dialog v-model="show1" :closeOnClickOverlay="true" :showConfirmButton="false">
      <div style="width: 100%;padding: 10px 0;">
        <van-radio-group v-model="radio" @change="changex">
          <div style="display: flex;align-items: center;padding: 0 0 0 10px;" v-for="(item, index) in list"
            :key="index">
            <img :src="item.remarks" alt="" class="img" />
            <van-cell :title="item.dictItemName" clickable @click="radio = item.dictItemCode">
              <template #right-icon>
                <van-radio :name="item.dictItemCode" />
              </template>
            </van-cell>
          </div>
        </van-radio-group>
      </div>
    </van-dialog>

    <div class="agreement-confirm-main-box" v-if="flag">
      <div class="agreement-confirm-box">
        <van-field v-model="bank" readonly :border="false" @click="show1 = true"  placeholder="请选择银行" class="inputn" right-icon="arrow-down" />
        <van-field type="digit" disabled :border="false" maxlength="11"  v-model="value" placeholder="请输入手机号" class="inputn" />
        <van-field type="text" v-model="bankName" :border="false" placeholder="请输入姓名" class="inputn" />
        <van-field type="text" maxlength="18" :border="false" v-model="idCardNo" placeholder="请输入身份证号" class="inputn" />
        <div class="btx " @click="pay1">提交</div>
      </div>
    
    </div>

    <div>
     
   
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { userApi, traceApi } from '@/api/index.js'
import CryptoJS from 'crypto-js'
import decryptData from '@/utils/decryptData.js'
import md5 from "@/utils/md5.js"
import JSEncrypt from 'jsencrypt'
import { mixedKey, swapsArray } from '../utils/key.js'
import { restoreShuffle } from '../utils/arrayUtils.js'
import params from "@/utils/param.js"
import { debounce } from 'lodash';
import store from '@/store/index.js'

export default {
  name: "ConTent",
  props: {
    img: String,
     btnimg: String,
    color: String,
    colorx: String,
    colorxy: String,
    showx:'',
    agree: Array,
    a: String,
    productCode: String,
    btnHeight: {
      type: [Number, String],
      default: 60
    },
    btnWidth: {
      type: [Number, String],
      default: 280
    },
    checkboxColor: {
      type: String,
      default: '#fff'
    },
    // 新增：设计稿宽度（和postcss-px-to-viewport配置一致）
    designWidth: {
      type: Number,
      default: 375 // 对应postcss配置的viewportWidth
    }
  },
  data() {
    return {
      bank: '',//银行
      bankCode: "",//银行编码
      list: [],
      radio: '',
      show1: false,
      bankName: '',//姓名
      idCardNo: '',//身份证号
      flag: false,
      param: "",
      value: '',
      checked: "",
      key: '',
      iv: "",
      data: "",
      decrypt: "",
      judgeType: '',
      env: "",
    };
  },
  watch: {
    checkboxColor: {
      immediate: true,
      handler(newColor) {
        this.$nextTick(() => {
          this.applyCheckboxColor(newColor)
        })
      }
    }
  },
  mounted() {
    this.applyCheckboxColor(this.checkboxColor)
    this.observeCheckboxDOM()
  },
  created() {
    if (/Android/.test(navigator.userAgent)) {
      this.judgeType = 'android'
    }
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      this.judgeType = 'ios'
    }
    this.getEnv()
  
    if (params.getParam(this.$route.query)) {
      this.param = params.getParam(this.$route.query)
    }
     this.value = JSON.parse(this.$route.query.param).mobile
  },
  methods: {
    // 核心：px转vw方法（完整实现，兼容postcss配置）
    pxToVw(px) {
      // 1. 转换为数字
      const numPx = Number(px);
      // 2. 容错：非数字/小于等于1px不转换
      if (isNaN(numPx) || numPx <= 1) return `${px}px`;
      // 3. 计算vw：(px值 / 设计稿宽度) * 100
      const vwValue = (numPx / this.designWidth) * 100;
      // 4. 保留2位小数，避免精度问题
      return `${vwValue.toFixed(2)}vw`;
    },

    changex(e) {
      for (var i in this.list) {
        if (this.list[i].dictItemCode == e) {
          this.bank = this.list[i].dictItemName
        }
      }
      console.log(this.bank)
      this.show1 = false
    },

    focus() {
      this.point(3)
    },

    applyCheckboxColor(color) {
      const finalColor = color || '#fff'
      this.$nextTick(() => {
        const icons = document.querySelectorAll('.hello .van-checkbox__icon .van-icon')
        icons.forEach(icon => {
          icon.style.setProperty('border-color', finalColor, 'important')
          icon.style.setProperty('background-color', 'transparent', 'important')
        })

        const checkedIcons = document.querySelectorAll('.hello .van-checkbox__icon--checked .van-icon')
        checkedIcons.forEach(icon => {
          icon.style.setProperty('border-color', finalColor, 'important')
          icon.style.setProperty('color', finalColor, 'important')
          icon.style.setProperty('background-color', 'transparent', 'important')
        })
      })
    },

    observeCheckboxDOM() {
      const observer = new MutationObserver(() => {
        this.applyCheckboxColor(this.checkboxColor)
      })

      if (this.$refs.checkboxWrapper) {
        observer.observe(this.$refs.checkboxWrapper, {
          childList: true,
          subtree: true,
          attributes: true
        })
      }
    },

    getEnv() {
      const ua = navigator.userAgent.toLowerCase()
      const isWechat = ua.includes('micromessenger')
      const isAlipay = ua.includes('alipayclient')
      const isAndroid = /android/.test(ua)
      const isIOS = /ipad|iphone|ipod/.test(ua)

      if (isWechat) {
        if (isAndroid) {
          userApi.fcFast({ userAgent: navigator.userAgent }).then(res => {
            this.env = res.support ? '0' : '1'
            this.$emit('env-change', this.env)
          })
          return
        }
        if (isIOS) {
          this.env = '2'
          this.$emit('env-change', this.env)
          return
        }
      }

      if (isAlipay) {
        this.env = '3'
        this.$emit('env-change', this.env)
        return
      }

      this.env = '4'
      this.$emit('env-change', this.env)
    },

    point(e, n) {
      traceApi.event({
        t: localStorage.getItem('traceId'),
        e: e,
        f: n
      })
    },

    pay1() {
      if (this.bankName == '') {
        this.$toast('姓名为空');
      } else if (!this.idCardNo.match(
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/)) {
        this.$toast('请输入正确的身份证号');
      } else {
        this.pay()
      }
    },

    pay: debounce(function () {
      for (var i in this.list) {
        if (this.list[i].dictItemName == this.bank) {
          this.bankCode = this.list[i].dictItemCode.substring(2)
        }
      }

      this.$store.commit('setLoading', true)
      this.point(9)
      userApi.generateToken({
        channelCode: this.a,
        productCode: this.productCode,
        mobile: this.value,
        traceId: localStorage.getItem('traceId')
      }).then((res) => {
        if (res.reason == 0) {
          this.key = CryptoJS.enc.Utf8.parse(md5.hex_md5(res.i))
          this.iv = CryptoJS.enc.Utf8.parse(res.i + '000')
          this.data = res.t

          userApi.register({
            mobile: this.value
          }).then((res1) => {
            localStorage.setItem('token', res1.accessToken);
            const encryptedData = CryptoJS.enc.Base64.parse(this.data);
            this.decrypt = decryptData.decryptData(encryptedData, this.key, this.iv)

            userApi.getchannel({
              channelCode: this.a
            }).then((res2) => {
              const decrypt = new JSEncrypt();
              decrypt.setPrivateKey(restoreShuffle(mixedKey.split('/'), swapsArray).join('/'))
              const decryptex = decrypt.decrypt(res2);
              const decryptexs = CryptoJS.enc.Utf8.parse((decryptex))

              var content = JSON.stringify({
                mobile: this.value,
                paymentMethod: "6",
                orderType: "1",
                channelCode: this.a,
                productCode: this.productCode,
                param: this.param,
                redirectUrl: window.location.href,
                userName: this.bankName,
                idCardNo: this.idCardNo,
                bankCode: this.bankCode,
              })
              const timestamp = Math.floor(new Date().getTime())
              var encryptResult = decryptData.cryptData(content, decryptexs, CryptoJS.enc.Utf8.parse(timestamp + '000'))

              userApi.signOrderHlb({
                channelCode: this.a,
                data: encryptResult,
                iv: timestamp + '000',
                t: this.decrypt,
                traceId: localStorage.getItem('traceId')
              }).then((res3) => {
                if (res3.reason == 0) {
                  this.$store.commit('setLoading', false)
                  let key = CryptoJS.enc.Utf8.parse(md5.hex_md5(this.decrypt))
                  let url = decryptData.decryptData(
                    CryptoJS.enc.Base64.parse(res3.encryptData),
                    key,
                    CryptoJS.enc.Utf8.parse(timestamp + '000')
                  )

                  let urls = JSON.parse(url).extInfo.signUrl
                  let signUrlHtmL = JSON.parse(url)
                    .extInfo?.signUrl.replace(
                      /\\/g, '')
                  //先判断.home-container下是否存在name==E_FORM的表单
                  if (document.querySelector(
                    'form[name="E_FORM"]')) {
                    //如果存在，则先删除
                    document.querySelector(
                      'form[name="E_FORM"]')
                      .remove()
                  }
                  //将signUrlHtmL插入类名为home-container的div最底部
                  document.querySelector(
                    '.home-container')
                    .insertAdjacentHTML(
                      'beforeend', signUrlHtmL)
                  //手动提交 name==E_FORM 的表单
                  document.querySelector(
                    'form[name="E_FORM"]')
                    .submit()
                }
              })
            })
          })
        }
      })
    }, 300),

    open() {
    
        if (!/^1[3456789]\d{9}$/.test(this.value)) {
          return this.$toast('请输入正确的手机号');
        }
        userApi.queryDictInfoHlbYs().then((res) => {
          console.log(res)
          this.list = res.dictItemList
          this.list.sort((a, b) => a.dictItemCode.substring(0, 2) - b.dictItemCode.substring(0, 2))
          console.log(this.list)
          setTimeout(() => {
            this.radio = this.list[0].dictItemCode
            this.bank = this.list[0].dictItemName
            this.flag = true
          }, 100);
        })
      
    },

    changebox(e) {
      if (e == true) {
        traceApi.event({
          t: localStorage.getItem('traceId'),
          obj: 5
        })
      }
    },

    change(e) {
      console.log(e)
      if (e.url) {
        window.location.href = e.url
      } else {
        console.log(e.id)
        if (e.id == 1) {
          this.$emit('ys', true)
        } else if (e.id == 3) {
          this.$emit('rule', true)
        }
      }
    },

    input() {
      if (this.value.length == 11) {
        if (!/^1[3456789]\d{9}$/.test(this.value)) {
          return this.$toast('请输入正确的手机号');
        }
        traceApi.event({
          t: localStorage.getItem('traceId'),
          e: 4,
          obj: this.value
        })
         this.$emit('showchange', false)
        localStorage.setItem('mobile', this.value)
        this.$nextTick(() => {
          const inputElement = this.$el.querySelector('.van-field__control')
          if (inputElement) {
            inputElement.blur()
          }
        })
        this.open()
      }else{
         this.$emit('showchange', true)
      }
    }
  }
}
</script>

<style scoped>
/* 原有样式保留，仅替换.agreement-confirm-main-box的样式 */
@keyframes butChange {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.hello {
  font-size: 20px;
  max-width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}

.btn {
  animation: butChange 1s infinite;
  margin-top: 14px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  object-fit: contain;
}

.check {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0 auto;
  margin-top: 10px;
  width: 90%;
  max-width: 320px;
  justify-content: flex-start;
  box-sizing: border-box;
  line-height: 14px;
}

.checkbox-wrapper {
  margin: 0 4px 0 0;
  flex-shrink: 0;
  padding: 0;
  display: flex;
  align-items: center;
  height: 14px;
}

.boss {
  flex: 1;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  margin: 0;
  padding: 0;
  line-height: 4px;
  text-align: left;
  overflow-wrap: break-word;
  box-sizing: border-box;
  font-size: 12px;
}

.agreest {
  line-height: 16px;
  display: inline;
  white-space: normal;
  word-break: break-all;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}

.agreest::after {
  content: none !important;
}

/* 外层容器样式（维持原有宽度） */
.inputs {
  width: 280px;
  background: #FFFFFF;
  border-radius: 25px;
  font-size: 18px;
  line-height: 26px;
  margin: 0 auto;
  display: block;
  box-sizing: border-box;
}

/* 核心修复：穿透修改Vant原生输入框的内边距（必加！） */
:deep(.inputs .van-field__control) {
  padding-left: 10px !important; /* 输入起点右移15px，可调整 */
  padding-right: 0 !important;
  box-sizing: border-box;
}

/* 可选：如果placeholder也需要偏移，加这个样式 */
:deep(.inputs .van-field__placeholder) {
  padding-left: 10px !important;
}

.check * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.hello>div {
  margin: 0;
  padding: 0;
}

@media (max-width: 375px) {
  .check {
    width: 90%;
  }
  .checkbox-wrapper {
    margin: 0 3px 0 0;
  }
}

@media (max-width: 320px) {
  .check {
    width: 95%;
  }
  .agreest {
    line-height: 16px;
  }
}

/* 核心修复：百度浏览器弹窗背景兼容 */
.agreement-confirm-main-box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%; /* 替换vw为%，兼容百度浏览器 */
  height: 100%; /* 替换vh为%，兼容百度浏览器 */
  display: -webkit-flex; /* 加webkit前缀 */
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-direction: column;
  flex-direction: column;
  /* 修复1：背景图加webkit前缀 + 强制覆盖 */
  background: url("https://qiming-1308147483.cos.ap-chengdu.myqcloud.com/doc%2Fpinzhi_shenghuo_huiyuan_quanyi%2Fcommon%2Flogin-shadow-bg.png") repeat !important;
  /* 修复2：加背景色兜底，防止图片加载失败 */
  background-color: rgba(0, 0, 0, 0.7) !important;
  z-index: 2; /* 提高层级，避免被遮挡 */
  /* 修复3：强制层叠上下文，防止背景被穿透 */
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  /* 修复4：强制渲染 */
  position: absolute;
  position: fixed;
}

.agreement-confirm-main-box .agreement-confirm-box {
  border-radius: 10px;
  -webkit-border-radius: 10px; /* 加webkit前缀 */
  background-color: #fff;
  padding: 15px;
  width: 80%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box; /* 加webkit前缀 */
  padding: 31px 29px 19px;
}

.inputn {
  height: 40px;
  border-radius: 6px;
  -webkit-border-radius: 6px; /* 加webkit前缀 */
  margin-top: 8px;
  border: 1px solid #EBEBEB;
}

.van-cell {
  line-height: 24px;
  padding: 10px 16px 10px 6px;
}

.van-cell__title {
  text-align: left;
}

.img {
  width: 21px;
  height: 21px;
}

.imgs {
  width: 24px;
  height: 24px;
  margin-top: 4px;
}

.btx {
  width: 100%;
  height: 40px;
  background: #FF7E00;
  border-radius: 5px;
  -webkit-border-radius: 5px; /* 加webkit前缀 */
  margin-top: 29px;
  color: #fff;
  font-size: 18px;
  display: -webkit-flex; /* 加webkit前缀 */
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

:deep(.van-checkbox__icon) {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  height: 1em;
  font-size: 15px !important; 
  line-height: 1em;
  cursor: pointer;
}
.boss1 {

    margin-top: 30px;
}
</style>